module.exports = __webpack_public_path__ + "static/media/logo192.a93ef4c4.png";